import {ChangeEvent, useEffect, useState} from 'react'
import {KTCard, KTCardBody} from '../../../../_metronic/helpers'
import LowBalance from './modal/LowBalance'
import {BASE_URL} from '../../config'
import axios from 'axios'
import toast from 'react-hot-toast'
import {useAuth} from '../../auth'
import {
  initNotificationConfigureFormValues,
  INotificationConfigAPI,
  INotificationConfigureFormValues,
} from '../_model'

const NOTIFICATION_SUBS_URL = `${BASE_URL}/api/protect/notificationSubscription`
const GET_NITIFICATION_SETUP_DETAILS = `${BASE_URL}/api/protect/getNotificationSubscriptionSetupDetails`

const SubscriptionsContent = () => {
  const {auth} = useAuth()
  const [checkedLowAccountBalance, setCheckedLowAccountBalance] = useState(false)
  const [checkedAccountBalance, setCheckedAccountBalance] = useState(false)

  const [notificationConfigureValues, setNotificationConfigureValues] =
    useState<INotificationConfigureFormValues>(initNotificationConfigureFormValues)
  const [isLow, setIsLow] = useState(true)
  const [isLoading, setIsLoading] = useState(false)

  const onChangeCheckedLowAccountBalance = async (e: ChangeEvent<HTMLInputElement>) => {
    const isCheck = e.target.checked
    setCheckedLowAccountBalance(isCheck)
    await subscriptionNotification(isCheck, 'lowAccountBalance')
  }

  const onChangeCheckedAccountBalance = async (e: ChangeEvent<HTMLInputElement>) => {
    const isCheck = e.target.checked
    setCheckedAccountBalance(isCheck)
    await subscriptionNotification(isCheck, 'accountBalance')
  }

  const subscriptionNotification = async (isCheck: boolean, subType: string) => {
    try {
      toast.loading('Processing..')
      const response = await axios.post(
        NOTIFICATION_SUBS_URL,
        {
          [subType]: isCheck ? '1' : '0',
        },
        {
          headers: {
            Authorization: `Bearer ${auth?.accessToken}`,
          },
        }
      )

      if (response.status === 202) {
        toast.dismiss()
        toast.success(response.data.message)
      }
    } catch (error) {
      toast.dismiss()
      console.log(error)
    }
  }

  const getSetupDetails = async () => {
    try {
      setIsLoading(true)
      toast.loading('Processing..')
      const response = await axios.get<INotificationConfigAPI>(GET_NITIFICATION_SETUP_DETAILS, {
        headers: {
          Authorization: `Bearer ${auth?.accessToken}`,
        },
        params: {
          isLow: isLow ? '1' : '0',
        },
      })

      console.log(response)

      if (response.status === 200) {
        toast.dismiss()
        toast.success('Success')
        const data = response.data
        console.log(data)
        setNotificationConfigureValues({
          notify_num: setMsisdn(data.notify_msisdn) || [],
          notify_msisdn: data.notify_msisdn || [],
          exportuseremail: data.notify_email || [],
          notify_email: data.notify_email || [],
          notify_email_cc: data.notify_email_cc || [],
          notify_email_bcc: data.notify_email_bcc || [],
          repeat_days: data.repeat_days || 0,
          low_balance_amount: data.low_balance_amount || 500,
        })

        setCheckedAccountBalance(data.account_balance[0] === '1' ? true : false)
        setCheckedLowAccountBalance(data.low_balance[0] === '1' ? true : false)

        setIsLoading(false)
      }
    } catch (error) {
      toast.dismiss()
      console.log(error)
      setIsLoading(false)
    }
  }

  const setMsisdn = (numbers: string[]) => {
    if (!numbers) return []
    return numbers.map((num) => ({value: num, label: num}))
  }

  useEffect(() => {
    getSetupDetails()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLow])

  return (
    <div className='mt-10'>
      <div className='fs-1 fw-medium'>Notification Subscriptions</div>
      <p className='text-gray-800 fw-medium fs-5'>
        Choose the topics that and the people that you want to notify.
      </p>

      <KTCard className='mt-10'>
        <KTCardBody>
          <table className='table table-row-dashed border-gray-300 align-middle gy-6'>
            <tbody className='fs-6 fw-bold'>
              <tr>
                <td>
                  <div className='d-flex flex-column'>
                    <span className='fs-3 text-dark text-hover-primary fw-bolder'>
                      Low account balance
                    </span>
                    <div className='fs-5 fw-bold text-gray-700'>
                      Know when your account reaches minimum balance
                    </div>
                  </div>
                </td>
                <td>
                  <button
                    className='text-uppercase text-gray-800 btn btn-transparent fw-bold'
                    type='button'
                    data-bs-toggle='modal'
                    data-bs-target='#kt_modal_1'
                    onClick={() => setIsLow(true)}
                  >
                    Configure
                  </button>
                </td>
                <td>
                  <div className='d-flex justify-content-end'>
                    <div className='form-check form-check form-switch'>
                      <input
                        className='form-check-input w-45px h-30px border border-gray-500'
                        type='checkbox'
                        id=''
                        checked={checkedLowAccountBalance}
                        onChange={onChangeCheckedLowAccountBalance}
                      />
                      <label className='form-check-label' htmlFor=''></label>
                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td>
                  <div className='d-flex flex-column'>
                    <span className='fs-3 text-dark text-hover-primary fw-bolder'>
                      Account balance
                    </span>
                    <div className='fs-5 fw-bold text-gray-700'>Daily account balance status</div>
                  </div>
                </td>
                <td>
                  <button
                    className='text-uppercase text-gray-800 btn btn-transparent fw-bold'
                    type='button'
                    data-bs-toggle='modal'
                    data-bs-target='#kt_modal_1'
                    onClick={() => setIsLow(false)}
                  >
                    Configure
                  </button>
                </td>
                <td>
                  <div className='d-flex justify-content-end'>
                    <div className='form-check form-check form-switch'>
                      <input
                        className='form-check-input w-45px h-30px border border-gray-500'
                        type='checkbox'
                        id=''
                        checked={checkedAccountBalance}
                        onChange={onChangeCheckedAccountBalance}
                      />
                      <label className='form-check-label' htmlFor=''></label>
                    </div>
                  </div>
                </td>
              </tr>

              {/* <tr>
                <td>
                  <div className='d-flex flex-column'>
                    <span className='fs-3 text-dark text-hover-primary fw-bolder'>
                      Campaign events
                    </span>
                    <div className='fs-5 fw-bold text-gray-700'>
                      Activity updates as they happen
                    </div>
                  </div>
                </td>
                <td>
                  <button
                    className='text-uppercase text-gray-800 btn btn-transparent fw-bold'
                    type='button'
                    data-bs-toggle='modal'
                    data-bs-target='#kt_modal_1'
                  >
                    Configure
                  </button>
                </td>
                <td>
                  <div className='d-flex justify-content-end'>
                    <div className='form-check form-check-solid form-switch'>
                      <input
                        className='form-check-input w-45px h-30px'
                        type='checkbox'
                        id=''
                        checked
                      />
                      <label className='form-check-label' htmlFor=''></label>
                    </div>
                  </div>
                </td>
              </tr> */}
            </tbody>
          </table>
        </KTCardBody>
      </KTCard>

      <LowBalance
        isLow={isLow}
        isLoading={isLoading}
        notificationConfigureValues={notificationConfigureValues}
      />
    </div>
  )
}

export default SubscriptionsContent
